<template>
<div>

<div>
    <div v-if="!file" class="align-center">
    <b-form-file
      v-model="file"
      v-on:change="onChange"
      :state="Boolean(file)"
      accept="image/jpeg"
      placeholder="Choose a file or drop it here..."
    >
    </b-form-file>
    </div>
 
    <div v-if="file" class="p-2 ">

      <b-container>
        <b-form-row>
          <b-col cols="7">
            <small>{{ file.name }} {{ dimensions }} {{ fileSize }} </small>
             <b-img fluid thumbnail  :src="image" />
          </b-col>
          <b-col>
             <b-form-group id="group-caption" label="Caption:" label-for="input-caption">
               <b-form-input id="input-caption" v-bind:disabled="isUploaded" v-model="form.caption" placeholder="Enter title of photo..." style="min-width:200px;"  maxlength="100"> </b-form-input>
             </b-form-group>
             <b-form-group id="group-remarks" label="Remarks:" label-for="input-remarks">
               <b-form-textarea id="input-remarks" v-bind:disabled="isUploaded" v-model="form.remarks" rows="4"  maxlength="1000"> </b-form-textarea>
             </b-form-group>

             <b-container>
               <b-row align-v="center">
                
                 <b-col cols="9">
                   <progress v-if="isBusy" max="100" :value.prop="uploadPercentage"></progress>
                   <b-alert v-model="isUploaded" >Photo uploaded to Journal.   &#10003;  </b-alert> 
                   <b-alert variant="danger" v-model="isError"> {{ error }} </b-alert> 
                 </b-col>
                
                 <b-col cols="3" >
                   
                   <b-button v-if="!isUploaded && !isBusy" v-on:click="submitFile()">Submit</b-button>
                   <b-spinner v-if="isBusy"></b-spinner>
                   <b-button v-if="isUploaded" @click="$emit('exit')">OK</b-button> 
                  
                 </b-col>

               </b-row>
             </b-container>
 
          </b-col>

        </b-form-row>

      </b-container>

    </div>

  </div>
     
    
 </div>
</template>

<script>
export default {
  name: 'AddImage',
   props: ['projectId','journalDate'],
   data: function() {
    return {
        file: null,
        image: '',
        isBusy: false,
        isUploaded: false,
        isError: false,
        error: '',
        uploadPercentage: 0,
        form: {
          caption: '',
          remarks: '',
        },
        dimensions: ''
    }

   },
 
   methods: {
       
       onChange(e){
        this.$emit("upsize");  //sets modal size to xl in parent data variable
        if (e.target.files.length > 0){
          this.file =  e.target.files[0]; //browse n choose
        } 
        else{
         this.file = e.dataTransfer.files[0]; //drag n drop 
        }
        this.createImage(this.file);
       },

      createImage(file) {
        var reader = new FileReader();
        reader.onloadend = (e) => {
          var img = new Image();
          img.src = this.image;
          if (img.width){
            this.dimensions = '(' + img.width + " x " + img.height + ')';
          };
        };
        reader.onload = (e) => {
          this.image = e.target.result;
         };
        
        reader.readAsDataURL(file);
        }, 
    
    submitFile() {
      this.isBusy = true;
      this.isError = false;

      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('Project', this.projectId);
      formData.append('JournalDate', this.journalDate);
      formData.append('Caption', this.form.caption.trim());
      formData.append('Remarks', this.form.remarks.trim());

        this.$auth.acquireToken().then(token => {
        this.$http
          .post("api/image", formData, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' },
            timeout: 60000,
            onUploadProgress: function( progressEvent ){
              this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
            }.bind(this)
          })
          .then(response => {
            this.isUploaded = true;
          })
          .catch(error => {
            this.isError = true;
            this.error = error;
            console.log("Failure!!");
            console.log(error);
          })
          .finally(() => (this.isBusy = false));
      });

    }
    
   },

  computed: {
    fileSize: function() {
      // megabytes=bytes/1024/1024
      var b = this.file.size;
      var kb = b/1024;
      var mb = kb/1024;

      if (mb>1){
        return Math.round(mb*10)/10 + " MB"
      }
      else{
        return Math.round(kb) + " KB"
      }
      
    }
  }
}
</script>

<style scoped>

</style>